<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="600"
    :loading="loading"
    @close="onClose"
    @ok="onSubmitFun"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-select
          title="区域"
          v-model:value="departmentId"
          :options="departments"
        />
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'

const api = new UserClass()
export default defineComponent({
  components: {},
  mixins: [form],
  props: {
    allowRoles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const title = ref('')

    const onClose = () => {
      loading.value = false
      visible.value = false
    }

    const departments = ref([])

    const departmentId = ref(0)
    const userId = ref('')

    return {
      title,
      visible,
      loading,
      departments,
      departmentId,
      userId,

      onClose
    }
  },

  methods: {
    open (data) {
      this.departmentId = data.departmentId
      this.userId = data.id

      this.getDepartments()
      this.title = data.name + '设置区域'
      this.visible = true
    },

    async getDepartments () {
      const list =
        this.$store.state.data.ALL_DEPARTMENTS.length > 0
          ? this.$store.state.data.ALL_DEPARTMENTS
          : await this.$store.dispatch('GetAllDepartment').then()

      const vlist = []
      list.map((e) => {
        vlist.push({
          label: e.name,
          value: e.id
        })
      })

      this.departments = vlist
    },

    onSubmitFun () {
      this.loading = true
      api.setDep(this.userId, this.departmentId).then(() => {
        this.$message.success('设置成功')
        this.$emit('ok')
        this.onClose()
      })
    }
  }
})
</script>
